import type { NewPurchaseNotificationsConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const newPurchaseNotificationsConfig: NewPurchaseNotificationsConfig = {
  recipients: [
    {
      contact: "jhercy.guayana@dawipo.com",
      company: "PROMED",
      send: true
    },
    {
      contact: "ap@cooweb.co",
      company: "PROMED",
      send: false
    }
  ]
}; 